import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";

const CATEGORIES = [
  {
    name: "Linen Edit",
    image: "https://images.unsplash.com/photo-1601053075908-11cb8deab951?w=400&h=400&fit=crop&q=80",
    link: "/search?q=women+linen",
  },
  {
    name: "Tailored Dresses",
    image: "https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=400&h=400&fit=crop&q=80",
    link: "/search?q=women+tailored+dresses",
  },
  {
    name: "Soft Knits",
    image: "https://images.unsplash.com/photo-1620799140188-3b2a02fd9a77?w=400&h=400&fit=crop&q=80",
    link: "/search?q=women+soft+knits",
  },
  {
    name: "Statement Tops",
    image: "https://images.unsplash.com/photo-1564222256577-45e728f2c611?w=400&h=400&fit=crop&q=80",
    link: "/search?q=women+statement+tops",
  },
  {
    name: "Relaxed Shirts",
    image: "https://images.unsplash.com/photo-1596755094514-f87e32f6b717?w=400&h=400&fit=crop&q=80",
    link: "/search?q=men+relaxed+shirts",
  },
  {
    name: "Smart Casual",
    image: "https://images.unsplash.com/photo-1617137984095-74e4e5e3613f?w=400&h=400&fit=crop&q=80",
    link: "/search?q=men+smart+casual",
  },
  {
    name: "Lightweight Jackets",
    image: "https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=400&h=400&fit=crop&q=80",
    link: "/search?q=men+lightweight+jackets",
  },
  {
    name: "Tailored Trousers",
    image: "https://images.unsplash.com/photo-1624378439575-d1ead6bb24b5?w=400&h=400&fit=crop&q=80",
    link: "/search?q=men+tailored+trousers",
  },
  {
    name: "View All",
    image: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=400&h=400&fit=crop&q=80",
    link: "/collections",
  },
];

export function CategoryCircles() {
  const scrollRef = useRef(null);

  const scroll = (dir) => {
    if (!scrollRef.current) return;
    const amount = scrollRef.current.offsetWidth * 0.6;
    scrollRef.current.scrollBy({ left: dir === "right" ? amount : -amount, behavior: "smooth" });
  };

  return (
    <section className="fashion-section border-b border-fashion-border pb-16">
      <div className="fashion-container">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-display text-display-sm font-light">Explore Collections</h2>
          </div>
          <div className="hidden md:flex items-center gap-2">
            <button
              onClick={() => scroll("left")}
              className="w-10 h-10 border border-fashion-border flex items-center justify-center hover:border-fashion-text transition-colors"
              aria-label="Previous"
            >
              <ChevronLeft className="h-4 w-4" strokeWidth={1.5} />
            </button>
            <button
              onClick={() => scroll("right")}
              className="w-10 h-10 border border-fashion-border flex items-center justify-center hover:border-fashion-text transition-colors"
              aria-label="Next"
            >
              <ChevronRight className="h-4 w-4" strokeWidth={1.5} />
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-6 md:gap-10 overflow-x-auto scrollbar-hide pb-4"
        >
          {CATEGORIES.map((cat, idx) => (
            <Link
              key={idx}
              to={cat.link}
              className="group flex flex-col items-center shrink-0 w-[100px] md:w-[140px]"
            >
              <div className="w-[100px] h-[100px] md:w-[140px] md:h-[140px] rounded-full overflow-hidden mb-4 border border-fashion-border">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
              </div>
              <span className="text-xs md:text-sm font-medium text-center uppercase tracking-wide group-hover:text-fashion-text-muted transition-colors">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
